import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { DeviceModel } from 'src/app/models/entities/device-model';
import { DeviceModelService } from 'src/app/services/device-model.service';
import { NbsUserService } from 'src/app/services/nbs-user.service';

@Component({
  selector: 'app-device-model-update',
  templateUrl: './device-model-update.component.html',
  styleUrls: ['./device-model-update.component.css']
})
export class DeviceModelUpdateComponent implements OnInit {

  destroy$ = new Subject<void>();
  form: FormGroup;
  constructor(
    private activatedRoute : ActivatedRoute,
    private formBuilder: FormBuilder,
    private router: Router,
    private toastrService: ToastrService,
    private deviceModelService: DeviceModelService,
    private userService: NbsUserService
  ) { }

  ngOnInit(): void {
    this.createForm();
    this.getDeviceModelById();
  }

  createForm() {
    this.form = this.formBuilder.group({
      id: 0,
      deviceModelName: ["", Validators.required],
      deviceModelCode: [""],
      brand: [""],
      reportTag1: [""],
      reportTag2: [""],
      reportTag3: [""],
      isActive: true
    })
  }

  getDeviceModelById(){
    const deviceModelId = parseInt(this.activatedRoute.snapshot.paramMap.get('deviceModelId'));
    this.deviceModelService.getById(deviceModelId).pipe(takeUntil(this.destroy$)).subscribe(data => {
      this.form.patchValue(data.data);
    })
  }

  update() {
    if (this.form.valid) {
      const deviceModel: DeviceModel = this.form.getRawValue();
      deviceModel.userId=this.userService.getUserId();
      this.deviceModelService.update(deviceModel).pipe(takeUntil(this.destroy$)).subscribe(
        data => {
          this.toastrService.success(data.message, "Başarılı");
          this.router.navigateByUrl('/device-model');
        },
        er => {
          this.toastrService.error(er.error.message, "Hata!");
        }
      );
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
  }

}
